import React from 'react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-[#FFF8F0] py-12 sm:py-24 px-4 overflow-visible" data-id="element-136">
      <div className="max-w-xl mx-auto relative" data-id="element-137">
        {/* Subtle background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#F5C84B]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-138" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} className="relative z-10" data-id="element-139">
          <div className="text-center mb-8 sm:mb-10" data-id="element-140">
            <h2 className="text-3xl sm:text-4xl font-black text-[#3D3935] mb-3" data-id="element-141">
              Empezá a usarlo <span className="text-[#F5A04B]" data-id="element-142">hoy mismo</span>
            </h2>
            <p className="text-[#8B7E76] text-sm sm:text-base font-medium" data-id="element-143">
              Acceso inmediato a todo el material + bonos exclusivos
            </p>
          </div>

          {/* Single Pricing Card */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-[0_8px_30px_rgba(245,200,75,0.15)] border-2 border-[#F5C84B]/30 relative" data-id="element-144">
            {/* Featured Ribbon */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#F5C84B] to-[#F5A04B] text-[#3D3935] text-[10px] sm:text-xs font-black px-4 py-1.5 rounded-full shadow-md border border-white/50 whitespace-nowrap z-20" data-id="element-145">
              ⭐ OFERTA ESPECIAL
            </div>

            <div className="text-center mb-6" data-id="element-146">
              <h3 className="text-xl sm:text-2xl font-black text-[#3D3935] mb-2" data-id="element-147">
                💛 MEGA PACK INCLUSIVO INFANTIL™
              </h3>
            </div>

            {/* Features List */}
            <ul className="space-y-3 mb-8" data-id="element-148">
              {['6 Tomos completos', '+500 recursos', '+98 libros para colorear', '6 bonos premium', 'Acceso inmediato'].map((feature, i) => <li key={i} className="flex items-center gap-3 text-[#3D3935] font-semibold text-sm sm:text-base" data-id="element-149">
                  <span className="text-[#F5A04B]" data-id="element-150">✅</span> {feature}
                </li>)}
            </ul>

            {/* Price Area */}
            <div className="text-center mb-8" data-id="element-151">
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-152">
                <span className="text-[#8B7E76] line-through text-sm sm:text-base font-bold" data-id="element-153">
                  Antes $79.990
                </span>
                <span className="bg-red-100 text-red-600 text-[10px] sm:text-xs font-black px-2 py-0.5 rounded-md" data-id="element-154">
                  -75%
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-155">
                <span className="font-black text-4xl sm:text-5xl tracking-tight text-[#3D3935]" data-id="element-156">
                  $19.990
                </span>
                <span className="text-[#8B7E76] text-sm font-bold" data-id="element-157">ARS</span>
              </div>
              <div className="inline-block bg-[#EAF6F0] text-[#22C55E] text-xs font-black px-3 py-1 rounded-full border border-[#22C55E]/20" data-id="element-158">
                AHORRÁS $60.000
              </div>
            </div>

            {/* CTA Button */}
            <motion.a href="https://www.iterapro.shop/cart/43354400358489:1" className="btn-brand-pulse relative block w-full text-center bg-gradient-to-b from-[#F5C84B] to-[#F5A04B] text-[#3D3935] font-black text-base sm:text-xl py-5 sm:py-6 rounded-2xl overflow-hidden group shadow-[0_0_40px_rgba(245,200,75,0.3),0_4px_20px_rgba(0,0,0,0.1)] hover:shadow-[0_0_60px_rgba(245,200,75,0.45),0_0_120px_rgba(245,200,75,0.15)]" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} transition={{
            type: 'spring',
            stiffness: 400,
            damping: 25
          }} data-id="element-159">
              {/* TODO: replace # with real Mercado Pago/Hotmart checkout URL */}
              {/* Inner highlight edge */}
              <div className="absolute inset-0 rounded-2xl border border-white/40 pointer-events-none" data-id="element-160" />
              {/* Top shine */}
              <div className="absolute inset-x-0 top-0 h-[45%] bg-gradient-to-b from-white/30 to-transparent rounded-t-2xl pointer-events-none" data-id="element-161" />
              {/* Hover sweep */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out pointer-events-none" data-id="element-162" />

              <span className="relative z-10 flex items-center justify-center gap-1.5 sm:gap-2 drop-shadow-[0_1px_1px_rgba(255,255,255,0.5)]" data-id="element-163">
                <span data-id="element-164">👉 SÍ, QUIERO MI MEGA PACK AHORA</span>
                <motion.span className="inline-flex items-center text-base sm:text-xl leading-none -mt-px" animate={{
                x: [0, 5, 0]
              }} transition={{
                duration: 1.2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-165">
                  →
                </motion.span>
              </span>
            </motion.a>

            {/* Local Currency Trust Line */}
            <p className="text-[#8B7E76] text-[11px] sm:text-sm font-bold text-center mt-4" data-id="element-166">
              <span className="inline-flex items-center align-middle mr-1 text-sm leading-none" data-id="element-167">
                🌎
              </span>
              Pagás en pesos argentinos · ⚡ Acceso automático después de
              comprar
            </p>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 mt-6 sm:mt-10" data-id="element-168">
            {[{
            icon: '🔒',
            text: 'Pago seguro'
          }, {
            icon: '⚡',
            text: 'Descarga inmediata'
          }, {
            icon: '🛡️',
            text: 'Garantía 7 días'
          }, {
            icon: '💳',
            text: 'Mercado Pago · Tarjeta'
          }].map((badge, i) => <div key={i} className="flex items-center gap-1.5 bg-white border border-[#EFE3D4] rounded-lg px-3 py-2 shadow-sm" data-id="element-169">
                <span className="text-sm" data-id="element-170">{badge.icon}</span>
                <span className="text-[#8B7E76] text-[10px] sm:text-xs font-bold" data-id="element-171">
                  {badge.text}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}